import React from 'react';
import { SkeletonLine, SkeletonCircle, Box } from '@wix/design-system';
export function SlimAppBoxSkeleton({ className, }) {
    return (React.createElement(Box, { className: className, width: "100%", height: "100%", direction: "vertical", align: "space-between" },
        React.createElement(Box, { direction: "vertical" },
            React.createElement(Box, { gap: "12px" },
                React.createElement(Box, { flexShrink: 0 },
                    React.createElement(SkeletonCircle, { diameter: "60px" })),
                React.createElement(Box, { width: "100%" },
                    React.createElement(Box, { direction: "vertical" },
                        React.createElement(SkeletonLine, { width: "72px", marginTop: "6px" }),
                        React.createElement(SkeletonLine, { width: "144px", marginTop: "12px" })))))));
}
//# sourceMappingURL=slim-app-box-skeleton.js.map